import { Role } from "tree-wallet-client";
import message from "antd/es/message";
import * as ImpersonationRepository from "../Repository/ImpersonationRepository";

export const IMPERSONATION_INDEX = 'tw_impersonate';

interface ImpersonationData {
  user: string;
}

export function arrayHasRole(roles: string[], targetRole: string): boolean {
  return roles.indexOf(targetRole) > -1;
}

export function getRoleFromArray(targetRole: string, rolesReference: Role[]): Role|undefined {
  try {
    for (const role in rolesReference) {
      const currentRole = rolesReference[role];
      if (currentRole.name === targetRole) {
        return currentRole;
      }
    }
    return undefined;
    // return Object.values(UserRoles).filter((currentRole: Role) => currentRole.name === targetRole)[0];
  } catch (err) {
    throw new Error('could not find role ' + targetRole);
  }
}

export function isImpersonating(): boolean {
  const data = getImpersonationData();
  return !!data && !!data.user;
}

export function getImpersonationData(): ImpersonationData|undefined {
  try {
    const storedData = localStorage.getItem(IMPERSONATION_INDEX);
    return storedData ? JSON.parse(storedData) : undefined;
  } catch (err) {
    return undefined;
  }
}

export function cleanup() {
  localStorage.removeItem('me');
  localStorage.removeItem('treeCount');
}

export function setImpersonationData(data: any) {
  // Store the current path before impersonation if this is the first time
  if (!localStorage.getItem(IMPERSONATION_INDEX)) {
    localStorage.setItem('pre_impersonation_path', window.location.pathname);
  }
  return localStorage.setItem(IMPERSONATION_INDEX, JSON.stringify(data));
}

export async function stopImpersonation() {
  try {
    await ImpersonationRepository.exitImpersonation();
    
    // Restore the admin user data if it exists
    const adminUser = localStorage.getItem('admin_user');
    if (adminUser) {
      try {
        const parsedAdminUser = JSON.parse(adminUser);
        localStorage.setItem('me', JSON.stringify(parsedAdminUser));
      } catch (e) {
        console.error('Error parsing admin user data:', e);
      }
    }
    
    // Get the pre-impersonation path or default to admin users page
    const preImpersonationPath = localStorage.getItem('pre_impersonation_path') || '/admin/users';
    
    // Clean up impersonation data
    localStorage.removeItem(IMPERSONATION_INDEX);
    localStorage.removeItem('pre_impersonation_path');
    localStorage.removeItem('admin_user');
    
    // Force a full page reload to ensure all context is reset
    window.location.href = preImpersonationPath;
  } catch (error) {
    // The API did not confirm the exit, so the session may still be the impersonated one: 
    // said out loud, because the cleanup below otherwise makes it look like the switch came back on its own
    console.error('Error stopping impersonation:', error);
    message.error('The impersonation could not be closed on the server');

    // Even if there's an error, try to clean up and redirect
    localStorage.removeItem(IMPERSONATION_INDEX);
    localStorage.removeItem('pre_impersonation_path');
    localStorage.removeItem('admin_user');
    window.location.href = '/admin/users';
  }
}

export function impersonateUser(user: string) {
  try {
    setImpersonationData({ user });
  } catch (err) {
    console.error(err);
  }
}
